import { BCMSClient } from '@becomes/cms-client';

export const relayClient = BCMSClient({
  cmsOrigin: 'https://pinkerton-reports.425244.com',
  key: {
    id: '62a72665391b939cba8f2bd1',
    secret: 'c178c79326a6c20ccf4ad366767f51ae11d73ac0af05d6e4fb4b5baf5fe15cfb',
  },
});
